@app.filter 'titlecase', ->
  (input) ->
    input = if input == undefined or input == null then '' else input
    input.toString().toLowerCase().replace /\b([a-z])/g, (character) ->
      character.toUpperCase()
